export const round2 = (num) =>
  Math.round((Number(num) + Number.EPSILON) * 100) / 100;

export const cenaBezDPHZeSDPH = (cenaSDPH, sazbaDPH = 21) => {
  const s = Number(cenaSDPH) || 0;
  const dph = Number(sazbaDPH) || 0;
  return round2(s / (1 + dph / 100));
};

export const castkaDPHZeSDPH = (cenaSDPH, sazbaDPH = 21) => {
  const s = Number(cenaSDPH) || 0;
  const bez = cenaBezDPHZeSDPH(s, sazbaDPH);
  return round2(s - bez);
};

export const celkemBezDPH = (pocet, cenaKsBezDPH) => {
  return round2((Number(pocet) || 0) * (Number(cenaKsBezDPH) || 0));
};

export const celkemSDPH = (pocet, cenaKsSDPH) => {
  return round2((Number(pocet) || 0) * (Number(cenaKsSDPH) || 0));
};

export const celkoveDPH = (pocet, cenaKsSDPH, sazbaDPH = 21) => {
  return round2((Number(pocet) || 0) * castkaDPHZeSDPH(cenaKsSDPH, sazbaDPH));
};

const txt = (v) => String(v ?? "").trim();

export const slozTextStuh = (item = {}) => {
  return [item.stuha1, item.stuha2, item.stuha3, item.stuha4]
    .map(txt)
    .filter(Boolean)
    .join(" | ");
};

export const prepocitejPolozkuKvetiny = (item = {}) => {
  const dph = Number(item.dph ?? 21) || 21;
  const cenaKsSDPH = Number(item.cenaKsSDPH ?? item.cenaSDPH ?? 0) || 0;
  const cenaKs = cenaBezDPHZeSDPH(cenaKsSDPH, dph);
  const pocet = Number(item.pocet ?? 0) || 0;

  const stuha1 = txt(item.stuha1);
  const stuha2 = txt(item.stuha2);
  const stuha3 = txt(item.stuha3);
  const stuha4 = txt(item.stuha4);

  const aktivniStuhy = [stuha1, stuha2, stuha3, stuha4].filter(Boolean);
  const pocetStuh = aktivniStuhy.length;
  const pocetStuhNavic = Math.max(0, pocetStuh - 2);

  const uctovatDalsiStuhy = item.uctovatDalsiStuhy !== false;
  const priplatekZaStuhuSDPH = Number(item.priplatekZaStuhuSDPH ?? 70) || 70;
  const priplatekStuhySDPH = uctovatDalsiStuhy ? round2(pocetStuhNavic * priplatekZaStuhuSDPH) : 0;
  const priplatekStuhyBezDPH = cenaBezDPHZeSDPH(priplatekStuhySDPH, dph);
  const priplatekStuhyDPH = round2(priplatekStuhySDPH - priplatekStuhyBezDPH);

  const zakladBezDPH = celkemBezDPH(pocet, cenaKs);
  const zakladSDPH = celkemSDPH(pocet, cenaKsSDPH);
  const zakladDPH = celkoveDPH(pocet, cenaKsSDPH, dph);

  return {
    ...item,
    dph,
    pocet,
    cenaKsSDPH,
    cenaKs,
    stuha1,
    stuha2,
    stuha3,
    stuha4,
    uctovatDalsiStuhy,
    priplatekZaStuhuSDPH,
    pocetStuh,
    pocetStuhNavic,
    priplatekStuhySDPH,
    priplatekStuhyBezDPH,
    priplatekStuhyDPH,
    poznamka: slozTextStuh({ stuha1, stuha2, stuha3, stuha4 }) || txt(item.poznamka),
    cenaZakladBezDPH: zakladBezDPH,
    cenaZakladSDPH: zakladSDPH,
    castkaZakladDPH: zakladDPH,
    cenaCelkemBezDPH: round2(zakladBezDPH + priplatekStuhyBezDPH),
    cenaCelkemSDPH: round2(zakladSDPH + priplatekStuhySDPH),
    castkaDPHCelkem: round2(zakladDPH + priplatekStuhyDPH),
  };
};

export const souctyKvetin = (polozky = []) => {
  return (Array.isArray(polozky) ? polozky : []).reduce(
    (acc, raw) => {
      const item = prepocitejPolozkuKvetiny(raw);
      acc.bezDPH = round2(acc.bezDPH + item.cenaCelkemBezDPH);
      acc.dph = round2(acc.dph + item.castkaDPHCelkem);
      acc.sDPH = round2(acc.sDPH + item.cenaCelkemSDPH);
      return acc;
    },
    { bezDPH: 0, dph: 0, sDPH: 0 }
  );
};
